import React, { useContext } from 'react';
import { api } from '../api';
import { PathwaysApi } from '../apis/pathways/pathways.api';

const PathwaysApiContext = React.createContext(new PathwaysApi(api));

export const PathwaysApiProvider = PathwaysApiContext.Provider;
export const usePathwaysApi = (): PathwaysApi =>
  useContext(PathwaysApiContext);
